import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { supportedLanguages } from '../i18n';
import App from '../App';

/**
 * 语言路由组件
 * 
 * 处理语言URL路径，将根路径重定向到默认语言路径，
 * 或基于浏览器的语言设置和用户之前的选择重定向到合适的语言路径
 */
const LanguageRouter = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // 修改标题的语言标签
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  
  // 当语言变更时，更新URL路径
  useEffect(() => {
    // 获取当前路径信息
    const path = location.pathname;
    const langPathMatch = path.match(/^\/([a-z]{2})(\/.*|$)/);
    
    // 当前URL中的语言代码
    const currentLangInPath = langPathMatch ? langPathMatch[1] : null;
    
    // 如果当前URL没有语言代码，或语言代码与当前语言不匹配
    if (currentLangInPath !== i18n.language) {
      // 构建新的路径
      let newPath;
      if (langPathMatch) {
        // 替换现有的语言代码
        newPath = `/${i18n.language}${langPathMatch[2] || ''}`;
      } else if (path === '/') {
        // 根路径直接添加语言
        newPath = `/${i18n.language}`;
      } else {
        // 其他路径前添加语言
        newPath = `/${i18n.language}${path}`;
      }
      
      // 使用replace而不是push，避免在历史记录中创建过多条目
      navigate(newPath, { replace: true });
    }
  }, [i18n.language, location.pathname, navigate]);
  
  return (
    <Routes>
      {/* 根路径重定向到当前/默认语言 */}
      <Route 
        path="/" 
        element={<Navigate to={`/${i18n.language || 'en'}`} replace />} 
      />
      
      {/* 为每种支持的语言创建路由 */}
      {supportedLanguages.map(lang => (
        <Route key={lang} path={`/${lang}/*`} element={<App />} />
      ))}
      
      {/* 捕获所有不匹配的路径，重定向到默认语言 */}
      <Route path="*" element={<Navigate to={`/${i18n.language || 'en'}`} replace />} />
    </Routes>
  );
};

export default LanguageRouter; 